/** People bulk moderation: selection, bulk bar, Block in Malfak, delete-all, badges, muted inbox. Owned by the People track. */
export const people = {
  bar: {
    toolbar: "Actions for the selected people",
    selected_one: "Selected: {{count}}",
    selected_other: "Selected: {{count}}",
    selectAll: "Select all on screen",
    selectAllFiltered_one: "Select all {{count}} matching",
    selectAllFiltered_other: "Select all {{count}} matching",
    allFiltered: "All matching people are selected",
    clear: "Clear selection",
    select: "Select @{{name}}",
    shiftHint: "Shift-click to select a range",
    more: "More actions",
    running: "Working on it…",
  },
  filters: {
    label: "Filters",
    blocked: "Blocked",
    blockedOpts: { all: "Anyone", only: "Blocked", exclude: "Not blocked" },
    flagged: "Tags",
    flaggedOpts: { all: "Anyone", only: "Tagged", exclude: "No tags" },
    has: "Their comments",
    hasOpts: { all: "Any", hidden: "Has hidden comments", deleted: "Has deleted comments", hidden_or_deleted: "Hidden or deleted" },
  },
  actions: {
    flag: "Tag",
    flagAdd: "Add a tag",
    flagRemove: "Remove a tag",
    mark: "Mark as",
    markClear: "Clear the mark",
    block: "Block in Malfak",
    unblock: "Unblock",
    hide: "Hide all their comments",
    unhide: "Unhide their comments",
    archive: "Archive all their comments",
    unarchive: "Unarchive their comments",
    delete: "Delete all their comments",
    export: "Export (CSV)",
    exported: "People exported",
    failed: "That didn't work",
    lockedRole: "Editors and above can do this",
    adminOnly: "Only admins and owners can delete all comments",
    hideConfirm: "Hide every comment from {{who}}?",
    hideHint: "Their comments are hidden on Instagram from other people. You can unhide them later.",
    unhideConfirm: "Unhide the hidden comments from {{who}}?",
    unhideHint: "Every hidden comment from them becomes visible on Instagram again.",
    archiveConfirm: "Archive every comment from {{who}}?",
    archiveHint: "Archived comments leave the inbox and post lists in Malfak. Nothing changes on Instagram.",
    unarchiveConfirm: "Bring back the archived comments from {{who}}?",
    who_one: "{{count}} person",
    who_other: "{{count}} people",
    done: "Done",
    started: "Started — follow it in Jobs",
  },
  block: {
    title: "Block {{who}} in Malfak",
    explain: "Instagram doesn't let apps block people, so this is Malfak's own block:",
    effects: {
      hide: "Their existing comments can be hidden now, and every new comment from them is hidden as soon as it arrives.",
      dms: "Their messages still arrive and are kept, but they're muted: out of the inbox, no notifications, no AI or automatic replies.",
      rules: "Rules skip them (except rules that use “Commenter is blocked in Malfak”).",
    },
    reason: "Reason (optional)",
    reasonPlaceholder: "e.g. repeated spam links",
    scope: "Where",
    scopeAll: "All accounts",
    scopeAccount: "Only @{{account}}",
    hideExisting: "Hide their existing comments now",
    visibleCount_one: "Visible comments now: {{count}}",
    visibleCount_other: "Visible comments now: {{count}}",
    confirm: "Block in Malfak",
    done: "Blocked in Malfak",
  },
  unblock: {
    title: "Unblock {{who}}?",
    hint: "New comments and messages from them are treated normally again.",
    unhide: "Also unhide the comments the block hid",
    unhideCount_one: "Hidden by the block: {{count}}",
    unhideCount_other: "Hidden by the block: {{count}}",
    confirm: "Unblock",
    done: "Unblocked",
  },
  delete: {
    title: "Delete all comments from {{who}}?",
    hint: "Each comment is deleted on Instagram, on your own posts only. Malfak keeps a copy marked “Deleted by Malfak” so nothing is lost. This can't be undone on Instagram.",
    counting: "Counting their comments…",
    impact: "Comments to delete: {{comments}} · People: {{people}}",
    none: "They have no comments left to delete.",
    typeToConfirm: "Type {{word}} to confirm",
    confirm: "Delete comments",
  },
  badge: {
    blocked: "Blocked",
    blockedTip: "Blocked in Malfak · {{scope}} · by {{by}} · {{when}}",
    blockedReason: "Reason: {{reason}}",
    scopeAll: "all accounts",
    scopeAccount: "one account",
    someone: "a teammate",
    muted: "Muted",
    mutedTip: "This person is blocked in Malfak: their messages are kept but muted.",
    hiddenByBlock: "Hidden: blocked",
    hiddenByBlockTip: "Hidden automatically because the author is blocked in Malfak.",
  },
  instagram: {
    block: "Block on Instagram",
    tip: "Instagram doesn't let apps block people. This opens their profile so you can block them in Instagram.",
  },
  quick: {
    blockPerson: "Block this person",
    unblockPerson: "Unblock this person",
    title: "Moderation",
  },
  inbox: {
    muted: "Muted (blocked people)",
  },
  /** ALP-84 S5: one People page with two views, and the Customer 360 links. */
  hub: {
    title: "People",
    hint: {
      everyone: "Everyone who commented or messaged you, one profile per person.",
      commenters: "Everyone who commented on one account, with tools to mark, hide or block.",
    },
    views: { label: "View", everyone: "Everyone", commenters: "Commenters" },
    layout: { label: "Layout", table: "Table", cards: "Cards" },
    columns: { select: "Select", person: "Person", lastActive: "Last active", comments: "Comments", status: "Status", actions: "Actions" },
    noStatus: "No status",
    filters: "Filters",
    filtersLabel: "Filter people",
    filtersOn: "Filters ({{n}} on)",
    clearFilters: "Clear filters",
    allTags: "All tags",
    openInbox: "Open inbox",
    noAccount: "Connect an account to see who comments",
    noAccountHint: "Commenters are listed per Instagram account.",
    connect: "Connect Instagram",
    openProfile: "Open profile",
    openConversation: "Open conversation",
    noConversation: "They haven't sent you a message yet",
    allComments: "All their comments",
    instagram: "Instagram",
    profileAndData: "Public profile and personal data",
    profileAndDataHint: "Refresh their profile from Instagram, export or delete their data.",
  },
};
